import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { SERVICE_TYPES } from '../../../../../helper/types';
import '../../../../../assets/styles/Services.css';

function Header({backToService, setActiveSection }) {

  const next = () => {
    setActiveSection(SERVICE_TYPES.REVIEW_TUNING);
  };

  const back = () => {
    setActiveSection(SERVICE_TYPES.NONE);
    backToService(true);
  };

  return (
    <div className="servicios-container" style={{ marginTop: '10px', width: '100%' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={6} container justifyContent="flex-start">
              <Typography sx={{ marginLeft: '100px', fontSize: '30px' }}>Asistencia Online y Telefónica</Typography>
            </Grid>
            <Grid item xs={3} container alignItems="center" justifyContent="flex-end">
              <Button onClick={back} sx={{ mr: '100px', textTransform: 'none', margin: '0px', color: 'black' }}>←Servicios</Button>
            </Grid>
            <Grid item xs={3} container alignItems="center" justifyContent="flex-end">
              <Button onClick={next} sx={{ mr: '100px', textTransform: 'none', color: 'black' }}>Revisión y Puesta a Punto→</Button>
            </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Header;
